import Image from "next/image"
import { VideoItemProps } from "./constants"
import Cookies from "js-cookie"
import { motion } from "framer-motion";
import { motionVariants } from "../Common/GlobalVars";


const VideoBanner = (props: VideoItemProps) => {
  const viewport = Cookies.get('viewport');

  return (
    <div className="relative video-banner bg-no-repeat bg-center bg-cover">
      <video
        src={props.video}
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 object-cover video-banner w-full">
      </video>
      <motion.div
        className={`absolute w-fit h-fit mx-[35px] md:mx-0 md:-translate-y-1/2 md:top-1/2 ${props.area_style}`}
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: true }}
        variants={motionVariants}
      >
        {props.brand_image !== null && props.brand_image.length > 0 && (
          <div className={`flex ${viewport === "desktop" ? props.style : props.mobile_style}`}>
            <Image
              src={props.brand_image}
              alt={props.brand_image_alt}
              width={props.brand_image_width}
              height={props.brand_image_height}
              quality={100}
              className={props.brand_image_style}
            />
          </div>
        )}
        <div
          className={`text-[32px] font-bold md:text-[48px] leading-normal -tracking-[2.4px] text-white font-dmsans ${viewport === "desktop" ? props.style : props.mobile_style}`}
          dangerouslySetInnerHTML={{ __html: props.title }}
        ></div>
      </motion.div>
    </div>
  )
}

export default VideoBanner
